"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markAndCheckDuplicate = void 0;
const utils_1 = require("@streamr/utils");
const DuplicateMessageDetector_1 = require("./DuplicateMessageDetector");
const markAndCheckDuplicate = (duplicateDetectors, currentMessage, previousMessageRef) => {
    const detectorKey = `${(0, utils_1.toUserId)(currentMessage.publisherId)}-${currentMessage.messageChainId}`;
    const previousNumberPair = previousMessageRef ?
        new DuplicateMessageDetector_1.NumberPair(Number(previousMessageRef.timestamp), previousMessageRef.sequenceNumber) : null;
    const currentNumberPair = new DuplicateMessageDetector_1.NumberPair(Number(currentMessage.timestamp), currentMessage.sequenceNumber);
    if (!duplicateDetectors.has(detectorKey)) {
        duplicateDetectors.set(detectorKey, new DuplicateMessageDetector_1.DuplicateMessageDetector());
    }
    return duplicateDetectors.get(detectorKey).markAndCheck(previousNumberPair, currentNumberPair);
};
exports.markAndCheckDuplicate = markAndCheckDuplicate;
//# sourceMappingURL=utils.js.map